import { useTranslation } from "react-i18next";
import type { UseFormRegisterReturn } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export interface CustomFieldFlagsProps {
  requiredProps: UseFormRegisterReturn;
  filterableProps: UseFormRegisterReturn;
  orderProps: UseFormRegisterReturn;
}

/**
 * The "is_required / is_filterable / order" row of the custom-field form,
 * extracted to keep `CustomFieldForm.tsx` under the 200-line threshold.
 */
export function CustomFieldFlags({
  requiredProps,
  filterableProps,
  orderProps,
}: CustomFieldFlagsProps) {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex items-center gap-4">
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" {...requiredProps} />
          {t("adminCustomFields.fields.isRequired")}
        </label>
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" {...filterableProps} />
          {t("adminCustomFields.fields.isFilterable")}
        </label>
      </div>
      <div>
        <Label htmlFor="cf-order">{t("adminCustomFields.fields.order")}</Label>
        <Input id="cf-order" type="number" min={0} {...orderProps} />
      </div>
    </>
  );
}
